"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.api = void 0;
exports.fetchWithRetries = fetchWithRetries;
exports.uploadFileInternal = uploadFileInternal;
const axios_1 = __importDefault(require("axios"));
const deployPrimeUrl = "https://master--eu-fyrms.netlify.app";
const context = "production";
const url = "https://eu.fyrms.com";
const apiKey = "" || "dev_api_key";
let baseUrl = "";
if (deployPrimeUrl) {
    baseUrl = deployPrimeUrl;
}
if (context === "production" && !!url) {
    baseUrl = url;
}
if (apiKey) {
    axios_1.default.defaults.headers.common["f-api-key"] = apiKey;
}
exports.api = axios_1.default.create({ baseURL: `${baseUrl}/.netlify/functions/` });
async function fetchWithRetries(url, step) {
    try {
        return await exports.api.get(url);
    }
    catch (error) {
        if (step < 5) {
            await new Promise(resolve => {
                setTimeout(resolve, 500);
            });
            return fetchWithRetries(url, step + 1);
        }
        else {
            throw error;
        }
    }
}
async function uploadFileInternal(filename, data) {
    const res = await axios_1.default.post(`${baseUrl}/.netlify/functions/filesint/base64/${filename}`, data.toString("base64"), {
        headers: { "f-api-key": apiKey }
    });
    if (res.status !== 200) {
        const sizeBytes = Buffer.byteLength(data, "base64");
        const sizeMegabytes = sizeBytes * 0.000001;
        const details = filename +
            ", " +
            sizeBytes +
            " bytes, " +
            sizeMegabytes.toFixed(2) +
            " megabytes";
        const msg = `failed to upload file (${details}) with status ${res.status}`;
        throw new Error(msg);
    }
    // return remote filename
    return res.data;
}
